import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ComplianceIssue } from "../issues/factory/model/compliance-issue.models";
import { RevRule } from "@shared/models/rev.model";
import { IndPhrase } from "@shared/models/cat.model";

@Component({
    selector: 'compliance-issues',
    templateUrl: './compliance-issues.component.html',
    styleUrls: ['./compliance-issues.component.scss'],
    standalone: false
})
export class ComplianceIssueComponent implements OnInit {

    @Input() complianceIssues: ComplianceIssue[];

    @Input() phrase: IndPhrase | RevRule;

    @Input() disableActions: boolean = false;

    @Output() removeComplianceIssueEmitter = new EventEmitter();

    ngOnInit(): void {}

    removeComplianceIssue(complianceIssue: ComplianceIssue) {

      let indexOf = this.complianceIssues?.indexOf(complianceIssue);
      if (indexOf != -1) {
        this.complianceIssues.splice(indexOf, 1);
      }
      complianceIssue.remove(this.phrase);
      
      this.removeComplianceIssueEmitter.emit();
      

    }
    
}